import { render, staticRenderFns } from "./elecciones2016.vue?vue&type=template&id=33d42924&"
import script from "./elecciones2016.vue?vue&type=script&lang=js&"
export * from "./elecciones2016.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports